module.exports = __webpack_public_path__ + "static/media/beginner2.bb54c9fd.gif";